import { render } from "./EmpView.vue?vue&type=template&id=fda17574"
import script from "./EmpView.vue?vue&type=script&lang=js"
export * from "./EmpView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__